<template>
	<div v-loading="l">
		<el-dialog title="审批" :visible.sync="show" width="30%">
			<det :row="row">
				<template v-slot:zhuangxiu>
					<div style="padding: 10px;">
						<div style="padding: 10px 0;" @click="xz(row.bmFile,row.bmFile.split('\\')[row.bmFile.split('\\').length-1])">商管审核附件 ： {{row.bmFile.split("\\")[row.bmFile.split("\\").length-1]}}</div>
						<div @click="xz(row.pmFile,row.pmFile.split('\\')[row.pmFile.split('\\').length-1])">物业审核附件 ： {{row.pmFile.split("\\")[row.pmFile.split("\\").length-1]}}</div>
					</div>
				</template>
				<template v-slot:tuizu>
					<div style="padding: 10px;">
						<span>店铺恢复原始状态: {{row.isRestore}}</span>
						<span class="left20">租金结清: {{row.isSettle}}</span>
					</div>
				</template>
			</det>
			<span slot="footer" class="dialog-footer">
				<el-button @click="show = false">取 消</el-button>
			</span>
		</el-dialog>
		<el-table :data="data" style="width: 100%" border>
			<el-table-column label="序号" type="index" align="center" width="50"></el-table-column>
			<el-table-column label="流程名称" align="center">
				<template slot-scope="{row}">{{jc(row)}}</template>
			</el-table-column>
			<el-table-column label="操作" align="center">
				<template slot-scope="{row}">
					<el-button type="text" @click="getRow(row)">详情</el-button>
				</template>
			</el-table-column>
		</el-table>
	</div>
</template>

<script>
	import det from "./det.vue"
	import downloadFile from '../../assets/js/downloadFile.js';
	export default {
		components: {
			det
		},
		data() {
			return {
				data: [],
				row: {},
				show: false,
				l:false
			}
		},
		computed: {
			jc() {
				return (row) => {
					console.log(row)
					let processKey = row.processKey
					if (processKey == "renovationProcess") {
						return "装修"
					}
					if (processKey == "shopReturnProcess") {
						return "退租"
					}
					if (processKey == "contractChange") {
						return "合同"
					}
					if (processKey == "attractInvestmentManage") {
						return "招商"
					}

					if (processKey == "visitProcess") {
						return "访客"
					}
					if (processKey == "subscribeLookProcess") {
						return "约看房"
					}
					if (processKey == "complaintProcess") {
						return row.data.type
					}
					if (processKey == "materialApplyProcess") {
						return "物资搬运"
					}
					if (processKey == "checkApplyProcess") { // 退换房
						return "退换房"
					}
					if(processKey=="meetingProcess"){
						return "商务审批"
					}
					if(processKey=="checkInProcess"){
						return "入住申请"
					}
				}
			}
		},
		methods: {
			xz(url,name) {
				downloadFile({url,name})
			},
			getRow(row) {
				this.row = row.data
				this.show = true
			},
			getValue() {
				let roleId = sessionStorage.roleId;
				if (roleId == 2) return "managerId";
				if (roleId == 5) return "managerId";
				if (roleId == 10) return "managerWuYeId";
				if (roleId == 11) return "managerShangGuanId";
			},
			getAll() {
				let queryKey = this.getValue()
				this.l = true
				this.$http.get(`/api/oa/contract/queryFinishedListByManagerId`, {
					params: {
						queryKey,
						value: sessionStorage.roleId,
						"managerId": sessionStorage.roleId,
						"pageNum": 1,
						"pageSize": 10,
					}
				}).then(res => {
					this.data = res.data.data
					this.l = false
				})
			}
		},
		mounted() {
			this.getAll()
		}
	}
</script>

<style>
</style>
